import { Box, Button, Link, Text } from '@chakra-ui/react';
import React from 'react';

import { ReactComponent as ArrowLeft } from '@/app/_icons/CkChevronLeftBlack.svg';
import { ReactComponent as CkClose } from '@/app/_icons/CkClose_black.svg';
import { ReactComponent as Home } from '@/app/_icons/home.svg';

import Styles from '../SellYourCarForm.module.scss';

interface FormHeaderProps {
  step: number;
  totalSteps: number;
  onBack: () => void;
  link: string;
  showBackButton: boolean;
}

const FormHeader: React.FC<FormHeaderProps> = ({
  step,
  totalSteps,
  onBack,
  link,
  showBackButton,
}) => {
  const isLastStep = step === totalSteps - 1;

  return (
    <>
      <Box className={Styles.megamenuHeader}>
        <Box className={Styles.megamenuFilter}>
          <Text className={Styles.headerTitle}>
            <Home /> Sell My Car
          </Text>
          <Link href="/sell-my-car" className={Styles.closeButton}>
            <CkClose />
          </Link>
        </Box>
      </Box>
      <Box className={Styles.stepCountSection}>
        <Box className={Styles.headerLeft}>
          <Text className={Styles.stepCount}>
            {step + 1}/{totalSteps}
          </Text>
          {showBackButton && !isLastStep && !(step === 0) ? (
            <Button
              variant="unstyled"
              className={Styles.backButton}
              onClick={onBack}
              aria-label="Go back"
            >
              <span className={Styles.backArrow}>
                <ArrowLeft /> Back
              </span>
            </Button>
          ) : (
            !isLastStep && (
              <Button
                variant="unstyled"
                className={Styles.backButton}
                aria-label="Go back"
              >
                <Link href={link}>
                  <span className={Styles.backArrow}>
                    <ArrowLeft /> Back
                  </span>
                </Link>
              </Button>
            )
          )}
        </Box>
      </Box>
    </>
  );
};

export default FormHeader;
